<template>
	<div class="ui-switch">
		<div class="arrow" :class="{ disabled: !is_prev_available }" v-hammer:tap="prev">
			<
		</div>
		<div class="text">{{ local_value.text | lang }}</div>
		<div class="arrow" :class="{ disabled: !is_next_available }" v-hammer:tap="next">
			>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
	name: 'ui-switch',
	data() {
		return {
			local_value: null
		}
	},
	props: {
		slug: { default: '' },
		value: { default: '' },
		options: { default: [] }
	},
	computed: {
		...mapGetters([ 'lang' ]),
		is_prev_available() {
			return this.options.findIndex((o) => o === this.local_value) > 0
		},
		is_next_available() {
			return this.options.findIndex((o) => o === this.local_value) < this.options.length - 1
		}
	},
	watch: {
		local_value() {
			if (!this.local_value || this.local_value.value !== this.value) {
				this.$emit('change', { slug: this.slug, value: this.local_value.value })
			}
		}
	},
	methods: {
		prev() {
			if (this.is_prev_available) {
				const index = this.options.findIndex((o) => o === this.local_value)
				this.local_value = this.options[index - 1]
			}
		},
		next() {
			if (this.is_next_available) {
				const index = this.options.findIndex((o) => o === this.local_value)
				this.local_value = this.options[index + 1]
			}
		}
	},
	created() {
		this.local_value = this.options.find(o => o.value === this.value)
	}
}
</script>

<style lang="stylus" scoped>
@import '../../assets/css/variables'

.ui-switch
	height 100%
	flex center center
	.arrow
		width 32px
		height 32px
		flex center center
		font-size 5rem
		margin 0 16px 0 0
		&:last-child
			margin 0 0 0 16px
		&.disabled
			opacity 0.25
			&:active
				transform none
		&:active
			transform translateY(2px)
		>>> svg
			width 20px
			height 20px
	.text
		width 80px
		text-align center
		font-size 3.2rem
		line-height 1em
		text-transform capitalize
		

</style>
